import { Grid, Icon, Paper, Typography } from "@mui/material";
import { PRIMARY_COLOR } from "../../_const/color.const";
import { theme } from "../../_styles/theme.styles";

const useStyles = {
    root: {
        display: 'flex',
        marginBottom: theme.spacing(1)
    },
    icon: {
        fontSize: 32,
        margin: theme.spacing(2),
    },
    iconPaper: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(-3),
        width: theme.spacing(8),
        height: theme.spacing(8),
        backgroundColor: `${PRIMARY_COLOR[0]} !important`,
        color: 'white !important',
        border: "1px solid white"
    },
    heading: {
        margin: theme.spacing(1),
        color: theme.palette.grey[600],
        alignItems: 'left',
        textAlign: 'left'
    },
    buttons: {
        "&>*": {
            float: "right"
        }
    }
};

export function PaperHeader(props: { title: String, icon?: String, children?: React.ReactNode }) {

    return (
        <Grid container>
            <Grid item xs={12} md={props.children ? 4 : 12} sm={props.children ? 5 : 12}>
                <div style={useStyles.root}>

                    <Paper sx={useStyles.iconPaper}>
                        <Icon sx={useStyles.icon}>{props.icon}</Icon>
                    </Paper>

                    <Typography variant="h5" component="h1" sx={useStyles.heading}>
                        {props.title}
                    </Typography>
                </div>
            </Grid>

            <Grid item xs={12} md={8} sm={7} sx={useStyles.buttons}>
                {props.children && props.children}
            </Grid>

        </Grid>
    );
}